import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PostTranslationsRoutingModule } from './postTranslations-routing.module';
import { PendingPostTranslationsFilterComponent } from './components/scripts/pendingPostTranslationsFilter.component';
import { PostTranslationsService } from './services/postTranslations.service';
import { FeedsService } from './services/feeds.service';
import { PostTranslationComponent } from './components/scripts/postTranslation.component';
import { MatNativeDateModule, MatAutocompleteModule } from '@angular/material';
import { BOMaterialModule } from '../material-module';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { MomentModule } from 'angular2-moment';
import { CKEditorModule } from 'ng2-ckeditor';
import { PostService } from '../shared/services/post.service';
import { TagService } from '../shared/services/tag.service';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

export const DATE_TIME_FORMATS = {
  parseInput: 'l LT',
  fullPickerInput: 'll HH:mm',
  datePickerInput: 'l',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    MomentModule,
    BOMaterialModule,
    PostTranslationsRoutingModule,
    CKEditorModule,
    BrowserModule,
    SharedModule,
    NgbModule.forRoot()
  ],
  declarations: [
    PendingPostTranslationsFilterComponent,
    PostTranslationComponent
  ],
  providers: [
    PostTranslationsService,
    PostService,
    TagService,
    FeedsService,
    { provide: OWL_DATE_TIME_FORMATS, useValue: DATE_TIME_FORMATS }
  ]
})

export class PostTranslationsModule { }



// WEBPACK FOOTER //
// ./src/app/postTranslations/postTranslations.module.ts